<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour severe"></div>
          <div class="damage-label">Severe</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour major"></div>
          <div class="damage-label">Major</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour minor"></div>
          <div class="damage-label">Minor</div>
        </div>
      </div>
    </div>

    <template v-if="damageForm && selectedVehicleType">
      <car-damage
        :car="damageForm"
        :damage="damage"
        :readonly="readonly"
        v-if="selectedVehicleType.name !== 'motorbike'"
      ></car-damage>

      <motorbike-damage
        :motorbike="damageForm"
        :damage="damage"
        :readonly="readonly"
        v-if="selectedVehicleType.name === 'motorbike'"
      ></motorbike-damage>
    </template>
  </div>
</template>
<script>
import MotorbikeDamage from './VehicleDamage/MotorbikeDamage';
import CarDamage from './VehicleDamage/CarDamage';

export default {
  props: {
    type: {
      type: [String, Number]
    },
    damage: {
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'car-damage': CarDamage,
    'motorbike-damage': MotorbikeDamage
  },

  data() {
    return {
      damageForm: null,
      selectedVehicleType: null
    };
  },

  computed: {
    types() {
      return this.$store.getters['VehicleTypes/all'];
    }
  },

  methods: {
    setVehicleType(id) {
      this.form.type_id = id;
      this.selectedVehicleType = this.types.find(type => type.id == id);
    },

    carDamageForm() {
      return new window.Form({
        description: null,
        rear_bumper: 0,
        rear_boot: 0,
        rear_windscreen: 0,
        roof: 0,
        front_windscreen: 0,
        top_bonnet: 0,
        front_bumper: 0,
        front_bonnet: 0,
        left_front_door: 0,
        left_front: 0,
        left_rear_door: 0,
        left_rear: 0,
        left_rear_wheel: 0,
        left_front_wheel: 0,
        right_front_door: 0,
        right_front: 0,
        right_rear_door: 0,
        right_rear: 0,
        right_front_wheel: 0,
        right_rear_wheel: 0
      });
    },

    motorbikeDamageForm() {
      return new window.Form({
        mb_front_head_lamp: 0,
        mb_front_left_handlebar: 0,
        mb_front_left_indicator: 0,
        mb_front_left_rear_view_mirror: 0,
        mb_front_right_handlebar: 0,
        mb_front_right_rear_view_mirror: 0,
        mb_front_main_body: 0,
        mb_front_right_indicator: 0,
        mb_front_wheel: 0,

        mb_left_seat: 0,
        mb_left_rear_wheel: 0,
        mb_left_rear_break_light: 0,
        mb_left_rear_right_indicator: 0,
        mb_left_main_body_engine: 0,
        mb_left_exhaust: 0,
        mb_left_rear_view_mirror: 0,
        mb_left_handlebar: 0,
        mb_left_front_wheel: 0,
        mb_left_indicator_light: 0,
        mb_left_front_head_light: 0,

        mb_rear_main_body: 0,
        mb_rear_right_handlebar: 0,
        mb_rear_right_rear_view_mirror: 0,
        mb_rear_left_handlebar: 0,
        mb_rear_left_rear_view_mirror: 0,
        mb_rear_front_right_indicator: 0,
        mb_rear_front_left_indicator: 0,
        mb_rear_fuel: 0,
        mb_rear_seat: 0,
        mb_rear_back_wheel: 0,
        mb_rear_right_indicator: 0,
        mb_rear_left_indicator: 0,
        mb_rear_brake_light: 0,

        mb_right_seat: 0,
        mb_right_rear_wheel: 0,
        mb_right_rear_break_light: 0,
        mb_right_rear_right_indicator: 0,
        mb_right_main_body_engine: 0,
        mb_right_exhaust: 0,
        mb_right_rear_view_mirror: 0,
        mb_right_handlebar: 0,
        mb_right_front_wheel: 0,
        mb_right_indicator_light: 0,
        mb_right_front_head_light: 0,

        mb_subframe_distortion_bend_cracks: false,
        mb_frame_distortion_bend_cracks_dents: false,
        mb_fuel_tank_leaking: false,
        mb_screen_smashed: false,
        mb_handlebars_bent_fuel_tank_contact_damaged_grips: false,
        mb_indicators_defective_broken: false,
        mb_clutch_break_levels_bent: false,
        mb_headlamp_defective_misaligned: false,
        mb_fairing_nose_cone_cracked_sharp_edges_loose: false,
        mb_forks_suspension_bent_dented_leaking_fork_oil: false,
        mb_break_components_damage_movement_scratches: false,
        mb_side_fairing_cracks_sharp_edges_loose: false,
        mb_engine_casing_cracks_dents_leaks: false,
        mb_gear_levers_break_pedal_bent: false,
        mb_r_and_f_mudguards_missing_insecure_damaged: false,
        mb_swing_arm_distorted_bent_cracks_dents: false,
        mb_chain_sprockets_chain_guard_serviceable: false,
        mb_spokes_missing_not_straight: false,
        mb_wheels_insecure_cracks_not_free_misaligned: false,
        mb_exhaust_insecure_hitting_suspension_holed_leaks: false,
        mb_foot_begs_bent: false,
        mb_tail_light_defective_cracks_sharp_edges: false,

        description: null
      });
    }
  },

  watch: {
    type(id) {
      this.selectedVehicleType = this.types.find(type => type.id == id);

      if (this.selectedVehicleType) {
        if (this.selectedVehicleType.name === 'motorbike') {
          this.damageForm = this.motorbikeDamageForm();
        } else {
          this.damageForm = this.carDamageForm();
        }
      } else {
        this.damageForm = null;
      }
    }
  }
};
</script>
